import styled from 'styled-components';

const Paragraph = styled.p`
  font-size: 16px;
`;

export default Paragraph;
